


















































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AppLogo extends Vue {
    @Prop() private size!: string;
    @Prop() private hide_text!: boolean;
    data() {
        return {
            text: ""
        }
    }

    created() {
        this.$data.text = this.$props.hide_text ? "hidden" : "shown";
    }
};

